import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { API_BASE_URL } from '../utils/axiosConfig';

const STORAGE_KEY = 'yapicrm_dil';
const CACHE_PREFIX = 'yapicrm_ceviriler_';

export function getAktifDil(): string {
    return localStorage.getItem(STORAGE_KEY) || 'tr';
}

export function setAktifDil(dilKodu: string) {
    localStorage.setItem(STORAGE_KEY, dilKodu);
}

async function ceviriYukle(dilKodu: string): Promise<Record<string, string>> {
    const cacheKey = CACHE_PREFIX + dilKodu;
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
        try { return JSON.parse(cached); } catch { }
    }

    try {
        const res = await fetch(`${API_BASE_URL}/api/Ceviriler/${dilKodu}`);
        if (!res.ok) return {};
        const data = await res.json();
        const ceviriler: Record<string, string> = data.ceviriler || {};
        sessionStorage.setItem(cacheKey, JSON.stringify(ceviriler));
        return ceviriler;
    } catch {
        return {};
    }
}

export async function i18nBaslat() {
    const dilKodu = getAktifDil();
    const ceviriler = await ceviriYukle(dilKodu);

    await i18next
        .use(initReactI18next)
        .init({
            lng: dilKodu,
            fallbackLng: 'tr',
            resources: {
                [dilKodu]: { translation: ceviriler },
            },
            interpolation: { escapeValue: false },
        });
}

export async function dilDegistir(dilKodu: string) {
    setAktifDil(dilKodu);
    const ceviriler = await ceviriYukle(dilKodu);

    const inst = i18next as any;
    if (!inst.hasResourceBundle(dilKodu, 'translation')) {
        inst.addResourceBundle(dilKodu, 'translation', ceviriler, true, true);
    }

    await inst.changeLanguage(dilKodu);
}

export default i18next;
